import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="shipping-address"
export default class extends Controller {
  static targets = ["checkbox", "form"]

  static values = {
    fields: { type: Array, default: ['name', 'address_line1', 'address_line2', 'city', 'state', 'zip_code', 'phone'] }
  }

  connect() {
    // Initially copy billing to shipping on page load
    this.copyBillingToShipping()
  }

  toggleShippingForm(event) {
    if (event.target.checked) {
      // Show shipping form when different address is selected
      this.formTarget.classList.remove('hidden')
      this.makeFieldsRequired(true)
    } else {
      // Hide shipping form and copy billing address
      this.formTarget.classList.add('hidden')
      this.copyBillingToShipping()
      this.makeFieldsRequired(false)
    }
  }

  copyBillingToShipping() {
    this.fieldsValue.forEach(field => {
      const billingField = document.querySelector(`input[name="order[billing_${field}]"], select[name="order[billing_${field}]"]`)
      const shippingField = document.querySelector(`input[name="order[shipping_${field}]"], select[name="order[shipping_${field}]"]`)

      if (billingField && shippingField) {
        shippingField.value = billingField.value
      }
    })
  }

  makeFieldsRequired(required) {
    this.fieldsValue.forEach(field => {
      // address_line2 is optional
      if (field === 'address_line2') return

      const shippingField = document.querySelector(`input[name="order[shipping_${field}]"], select[name="order[shipping_${field}]"]`)
      if (shippingField) {
        shippingField.required = required
      }
    })
  }

  // Listen to billing field changes and copy to shipping if not using different address
  handleBillingChange() {
    if (!this.checkboxTarget.checked) {
      this.copyBillingToShipping()
    }
  }
}
